//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


  export default {
    name: "morePage",
    data() {
      return {
        rateConfig: null,
        list: [],
        noMore: false,
        finished: false,
        total: '',
        pageNo: 0,
        loading: true,
        code: '',
        templateClass: '',
        listClass: '',
        show: false,
        titleData: '',
        defaultbg: require("@/assets/image/icon/defaultbg.jpg"),
        iconAuthor: require("@/assets/image/icon/icon_author.png"),
        iconSound: require("@/assets/image/icon/icon_sound.png"),
        targetL: {
          //跳轉地址配置
          column: {
            path: "detail",
            params: [{ name: "dataId", label: "id"}] //跳轉所需參數
          },
          video: {
            path: "videoDetail",
            params: [{ name: "dataId", label: "id"}]
          },
          audio: {
            path: "audioDetail",
            params: [{ name: "dataId", label: "id"}]
          },
          ebook: {
            path: "ebookDetail",
            params: [{ name: "dataId", label: "id"}]
          }
        }
      };
    },
    methods: {
      //返回上一页
      onClickLeft(){
        this.$router.go(-1)
      },
      getData(pageNo){
        let that = this;
        let postD = {
          appid: this.SERVER.APPID,
          pageCode: this.code,
          pageNo: this.pageNo,
          pageSize: 18
        };
        that.pageNo = pageNo;
        //this.$toast.loading();
        this.GLOBAL_.ccRequest.doAxios(this.CONFIG.BLOCK.GETLIST, postD, "POST", "no login")
          .then(res => {
            console.log("res11", res, pageNo);
            //this.$toast.close();
            this.total = res.total
            if(pageNo == 1){
              that.list = res.rows;
            }else{
              that.list = that.list.concat(res.rows);
            }
            if(res.total < 18 && pageNo == 1){
              that.finished = true
            }

            if (res.rows.length == 0 || that.list.length == res.total) {
              that.loading = false;
              that.noMore = true
            } else {
              that.loading = true;
            }

            this.$forceUpdate();
            this.show = true;

          }).catch(err => {
            console.log("err", err);
          });
      },
      getScrollDate() {
        let that = this;
        let nScroll = document.documentElement.scrollTop || document.body.scrollTop;
        let nClientHeight = document.documentElement.clientHeight;
        if ( nScroll + nClientHeight >= document.body.scrollHeight - 50 && that.loading) {
          that.loading = false;
          that.pageNo = that.pageNo + 1;
          that.getData(that.pageNo)
        }

      },
      gotoTarget2(item,ind) {
        //let item = item.bookRel;
        //console.log('item',item);
        let types = item.columnCode; //类型
        let dataType = item.dataType; //专辑还是详情
        let target = this.targetL[types];
        if(dataType == 'medialist'){
          target = this.targetL['column'];
        }else{
          target = this.targetL[types];
        }
        if (target == undefined) {
          //未配置的目標地址
          // console.log("error", "未配置的目標地址");
          return;
        }
        let pArr = target.params;
        let q = {};
        let obj = {};
        obj["path"] = target.path;
        console.log('pArr',pArr);
        pArr.forEach(p => {
          let val = item[p.name];
          //如果有傳入LABLE則，使用LABEL作為屬性值，沒有則使用name作為參數值
          let key = p.label ? p.label : p.name;
          q[key] = val;
        });

        obj["query"] = q;
        //console.log(obj, q);
        this.GLOBAL_.ccApp.navigateTo(this.$router, obj);
      }
    },
    mounted() {
      //单位
      this.rateConfig = JSON.parse(localStorage.getItem('rateConfig'))
      console.log('rateConfig',localStorage.getItem('rateConfig'), this.rateConfig);

      this.code = this.$route.query.code;
      switch(this.code){
        case 'index_audioBook':
          this.titleData = this.$t('INDEX_LANG.menu.2');
          this.code = 'index_audioBook';
          this.templateClass = 'book_wrap';
          this.listClass = 'book_list';
          break;
        case 'index_ebook':
           this.titleData = this.$t('INDEX_LANG.menu.3');
           this.code = 'index_ebook';
           this.templateClass = 'book_wrap';
           this.listClass = 'book_list';
           break;
        case 'index_course':
          this.titleData = this.$t('INDEX_LANG.menu.1');
          this.code = 'index_course';
          this.templateClass = 'course_wrap course_circular_wrap';
          this.listClass = 'course_list';
          break;
        case 'index_talkbook':
          this.titleData = this.$t('INDEX_LANG.menu.0');
          this.code = 'index_talkbook';
          this.templateClass = 'course_wrap';
          this.listClass = 'course_list';
          break;
        case 'index_video':
          this.titleData = this.$t('INDEX_LANG.menu.4');
          this.code = 'index_video';
          this.templateClass = 'video_wrap';
          this.listClass = 'video_list';
          break;
        case 'index_complex1':
          this.titleData = this.$route.query.title;
          this.code = 'index_complex1';
          this.templateClass = 'course_wrap';
          this.listClass = 'course_list';
          break;
        case 'index_complex2':
          this.titleData = this.$route.query.title;
          this.code = 'index_complex2';
          this.templateClass = 'book_wrap';
          this.listClass = 'book_list';
          break;
        case 'index_complex3':
          this.titleData = this.$route.query.title;
          this.code = 'index_complex3';
          this.templateClass = 'book_wrap';
          this.listClass = 'book_list';
          break;
      };

      if(this.pageNo == 0){
        this.getData(1);
        this.loading = false;
      }
      window.addEventListener("scroll", this.getScrollDate);
    },
    beforeRouteLeave(to, from, next) {
      //console.log('to', to.path, to);
      if(to.path == '/detail' || to.path == '/ebookDetail' || to.path == '/audioDetail' || to.path == '/videoDetail') {
        from.meta.keepAlive = true
      } else {
        from.meta.keepAlive = false
      }
      next()
    },
    beforeDestroy() {
      //销毁滚动事件
      window.removeEventListener("scroll", this.getScrollDate);
    }
  };
  


// WEBPACK FOOTER //
// ./src/pages/morePage.vue